"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectPath = _interopRequireDefault(require("object-path"));

var _lodash = _interopRequireWildcard(require("lodash"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Mutations = /*#__PURE__*/function () {
  function Mutations() {
    _classCallCheck(this, Mutations);
  }

  _createClass(Mutations, null, [{
    key: "create",
    value: function create(fields, oldObject, newObject) {
      var mutations = [];
      fields.forEach(function (field) {
        var mutation = Mutations.createMutation(field, oldObject, newObject);

        if (mutation) {
          mutations.push(mutation);
        }
      });
      return mutations;
    }
  }, {
    key: "createMutation",
    value: function createMutation(field, oldObject, newObject) {
      var oldField = _objectPath["default"].get(oldObject, field);

      var newField = _objectPath["default"].get(newObject, field);

      if ((0, _lodash.isEqual)(oldField, newField) === false) {
        return {
          action: 'set_field',
          field: field,
          value: newField
        };
      }

      return null;
    }
  }, {
    key: "createArrayByKey",
    value: function createArrayByKey(field, keys, oldObject, newObject) {
      var oldField = _objectPath["default"].get(oldObject, field);

      var newField = _objectPath["default"].get(newObject, field); // If oldField is the same as newField, no mutations are going to be created


      if (oldField === newField) {
        return null;
      } // Check if types changed
      // If so, that's a real change of the whole value


      if (_typeof(oldField) !== _typeof(newField)) {
        return [{
          action: 'set_field',
          field: field,
          value: newField
        }];
      } // Mutations array


      var mutations = []; // Set keys to array, if it's a string

      if (typeof keys === 'string') keys = [keys]; // Create remove mutations

      oldField.forEach(function (item, idx) {
        if (!newField.find(function (row) {
          return keys.every(function (key) {
            return row[key] === item[key];
          });
        })) {
          mutations.push({
            action: 'remove_from_array_by_multiple_key_values',
            field: field,
            key_values: keys.map(function (key) {
              return {
                key: key,
                value: item[key]
              };
            })
          });
        }
      }); // Create new mutations

      newField.forEach(function (item, idx) {
        // Check if a new item
        var oldItem = oldField.find(function (row) {
          return keys.every(function (key) {
            return row[key] === item[key];
          });
        });

        if (!oldItem) {
          return mutations.push({
            action: 'array_push',
            field: field,
            value: item
          });
        } // Check if difference in item


        if (_lodash["default"].isEqual(item, oldItem) === false) {
          return mutations.push({
            action: 'set_array_item_by_multiple_key_values',
            field: field,
            key_values: keys.map(function (key) {
              return {
                key: key,
                value: item[key]
              };
            }),
            value: item
          });
        }
      });
      return mutations;
    }
  }]);

  return Mutations;
}();

exports["default"] = Mutations;